import type { Template } from "@/types";

export const LA_04_H4_V0: Template[] = [
    {
        id: "la-04-h4v0-01",
        name: "LA 01 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 149, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 149, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 149, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 149, width: 332, height: 232, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-02",
        name: "LA 02 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 49, y: 45, width: 312, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 361, y: 271, width: 312, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 271, width: 311, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 45, width: 311, height: 217, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-03",
        name: "LA 03 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 168, y: 52, width: 340, height: 210, rotation: 0, imageRotation: 0 },
            { id: "2", x: 168, y: 270, width: 340, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 844, y: 52, width: 340, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 844, y: 270, width: 340, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-04",
        name: "LA 04 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 253, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 253, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 253, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 253, width: 293, height: 205, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-05",
        name: "LA 05 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 239, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 239, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 239, width: 332, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 239, width: 332, height: 232, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-06",
        name: "LA 06 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 47, y: 52, width: 304, height: 210, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 269, width: 304, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1001, y: 52, width: 304, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1001, y: 269, width: 304, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-07",
        name: "LA 07 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 73, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 73, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 73, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 73, width: 293, height: 205, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-08",
        name: "LA 08 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 221, y: 40, width: 233, height: 145, rotation: 0, imageRotation: 0 },
            { id: "2", x: 221, y: 193, width: 233, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 221, y: 345, width: 233, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 738, y: 73, width: 552, height: 384, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-09",
        name: "LA 09 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 103, y: 214, width: 450, height: 265, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 53, width: 221, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 53, width: 221, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 75, width: 591, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-10",
        name: "LA 10 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 51, width: 684, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1074, y: 51, width: 229, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1074, y: 196, width: 229, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1074, y: 342, width: 229, height: 136, rotation: 0, imageRotation: 0 }
        ],
    }
];